import React from "react";
import Loader from "react-loaders";
import { Card, CardBody } from "reactstrap";
import Contactgegevens from "./Contactgegevens";
import Rollen from "./Rollen";
import LaatsteLogin from "./LaatsteLogin";
import Verzoeken from "./Verzoeken";
import SendSMS from "./SendSMS";
import { useGebruikerContext } from "../../Context/GebruikerContext";

const Profiel = ({ children }) => {
	const { isLoading } = useGebruikerContext();

	if (isLoading)
		return (
			<Card className="main-card">
				<CardBody className="d-flex flex-column">
					<Loader
						type="ball-grid-pulse"
						className={"mt-3 d-flex mx-auto justify-content-center"}
					/>
				</CardBody>
			</Card>
		);

	return <div className="row profile">{children}</div>;
};

Profiel.Contactgegevens = () => {
	return (
		<div className="col-lg-6">
			<Contactgegevens />
		</div>
	);
};

Profiel.Wrapper = ({ children }) => {
	return (
		<div className="col-lg-6">
			<div className="sec-row">{children}</div>
		</div>
	);
};

Profiel.Rollen = () => {
	return (
		<div className="col-12">
			<Rollen />
		</div>
	);
};

Profiel.Verzoeken = () => {
	return (
		<div className="col-xxl-6">
			<Verzoeken />
		</div>
	);
};

Profiel.LaatsteLogin = () => {
	return (
		<div className="col-12">
			<LaatsteLogin />
		</div>
	);
};

Profiel.SendSMS = () => {
	return (
		<div className="col-xxl-6">
			<SendSMS />
		</div>
	);
};

export default Profiel;
